import React, { useEffect, useState } from 'react';
import { BonadocsEditorViewPlaygroundMethodControlbarItem } from '../../BonadocsEditorViewPlayground/BonadocsEditorViewPlaygroundMethod/BonadocsEditorViewPlaygroundMethodControlbar/BonadocsEditorViewPlaygroundMethodControlbarItem';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { BonadocsEditorViewActionsCodeView } from './BonadocsEditorViewActionsCodeView';
import { BonadocsEditorViewActionsCodeButton } from './BonadocsEditorViewActionsCodeButton';
import { BonadocsEditorViewActionsCodeDocs } from './BonadocsEditorViewActionsCodeDocs';
import { Popover } from '@headlessui/react';
import { usePopper } from 'react-popper';
import { BonadocsEditorViewActionsCodeModal } from './BonadocsEditorViewActionsCodeModal';
import { useCollectionContext } from '@/context/CollectionContext';

interface BonadocsEditorViewActionsCodeProps {}

export const BonadocsEditorViewActionsCode: React.FC<
  BonadocsEditorViewActionsCodeProps
> = () => {
  const [currentChain, setCurrentChain] = useState<string>('');
  const currentAction = useSelector(
    (state: RootState) => state.action.currentAction,
  );
  const actionList = useSelector(
    (state: RootState) => state.action.collectionActions,
  );
  const cloudIcon = useSelector(
    (state: RootState) => state.controlBoard.cloudIcon,
  );
  const [currentCode, setCurrentCode] = useState<boolean>(true);

  const activeActionValidity = actionList.find(
    (action) => action.id === currentAction.id,
  );
  const [block, setBlock] = useState<boolean>(false);
  let [referenceElement, setReferenceElement] = useState<any>();
  let [popperElement, setPopperElement] = useState<any>();
  let { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-end',
    strategy: 'absolute',
  });
  const { getCollection } = useCollectionContext();
  const collection = getCollection();

  const updateChain = async () => {
    const valueView = await collection!.getValueManagerView();
    const chainValue = await valueView.getString(
      `workflow-chain-id-${currentAction.id}`,
    );
    setCurrentChain(chainValue);
  };

  useEffect(() => {
    updateChain();
  }, [currentAction]);

  return (
    <div className="bonadocs__editor__dashboard__playground__action__code">
      {currentAction.name && activeActionValidity && (
        <>
          <div className="bonadocs__editor__dashboard__playground__method__controlbar">
            <BonadocsEditorViewPlaygroundMethodControlbarItem
              active={currentCode}
              onClick={() => setCurrentCode(true)}
            >
              {currentAction.name}
            </BonadocsEditorViewPlaygroundMethodControlbarItem>
            <BonadocsEditorViewPlaygroundMethodControlbarItem
              active={!currentCode}
              onClick={() => setCurrentCode(false)}
            >
              Documentation
            </BonadocsEditorViewPlaygroundMethodControlbarItem>
            <div className="mal-auto">
              {cloudIcon && (
                <img
                  className="bonadocs__editor__dashboard__playground__method__controlbar__cloud"
                  src="https://res.cloudinary.com/dfkuxnesz/image/upload/v1715148623/cloud-off_xqq3nc.svg"
                />
              )}
              <Popover className="ma-auto relative">
                <Popover.Button ref={setReferenceElement}>
                  <svg
                    className="bonadocs__editor__dashboard__playground__method__controlbar__cloud"
                    width="50"
                    height="24"
                    viewBox="0 0 50 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25 6C25.5523 6 26 5.55228 26 5C26 4.44772 25.5523 4 25 4C24.4477 4 24 4.44772 24 5C24 5.55228 24.4477 6 25 6Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M25 13C25.5523 13 26 12.5523 26 12C26 11.4477 25.5523 11 25 11C24.4477 11 24 11.4477 24 12C24 12.5523 24.4477 13 25 13Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M25 20C25.5523 20 26 19.5523 26 19C26 18.4477 25.5523 18 25 18C24.4477 18 24 18.4477 24 19C24 19.5523 24.4477 20 25 20Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </Popover.Button>
                <Popover.Panel
                  ref={setPopperElement}
                  style={styles.popper}
                  {...attributes.popper}
                  className="bonadocs__editor__variables__table__item__popover"
                >
                  {({ close }) => (
                    <>
                      <div className="bonadocs__editor__variables__table__item__popover__item pa-sm">
                        <div
                          onClick={() => {
                            setBlock(!block);
                            close();
                          }}
                          className="bonadocs__editor__variables__table__item__popover__item__edit font-sm"
                        >
                          Block number
                        </div>
                      </div>

                      <img src="/solutions.jpg" alt="" />
                    </>
                  )}
                </Popover.Panel>
              </Popover>
            </div>
          </div>

          {currentCode ? (
            <>
              <BonadocsEditorViewActionsCodeView />
              <BonadocsEditorViewActionsCodeButton />
            </>
          ) : (
            <BonadocsEditorViewActionsCodeDocs
              docs={currentAction.documentation!}
            />
          )}
        </>
      )}
      <BonadocsEditorViewActionsCodeModal
        closeBlockModal={() => setBlock(!block)}
        show={block}
        chainId={currentChain}
      />
    </div>
  );
};
